<template>
  <div>
    <div class="menuHeader">
      <div class="menuItem" @click="toggleMenu()">
        <BIconThreeDots class="menuIcon"></BIconThreeDots>
      </div>
      <div class="menuItem" v-if="menuOpen" @click="goto('workoutView')"><BIconCardList class="menuIcon"></BIconCardList></div>
      <div class="menuItem" v-if="menuOpen && userWorkouts.length <= 6" @click="goto('addWorkout')">
        <BIconFilePlusFill class="menuIcon"></BIconFilePlusFill>
      </div>
      <div class="menuItem" v-if="menuOpen" @click="goto('importWorkout')"><BIconCloudUploadFill class="menuIcon"></BIconCloudUploadFill></div>
      <div class="menuItem" v-if="menuOpen" @click="goto('emom')"><BIconController class="menuIcon"></BIconController></div>
      <div class="menuItem" v-if="menuOpen" @click="goto('aboutView')"><BIconQuestionCircleFill class="menuIcon"></BIconQuestionCircleFill></div>
      <div class="menuItem" v-if="menuOpen" @click="logout()"><BIconBoxArrowRight class="menuIcon"></BIconBoxArrowRight></div>
    </div>
    <div class="mobileView">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { provideToast, useToast } from 'vue-toastification/';
import { dbConnection } from '@/firestore/firestore';
import {
  BIconBoxArrowRight,
  BIconCardList,
  BIconThreeDots,
  BIconFilePlusFill,
  BIconQuestionCircleFill,
  BIconCloudUploadFill,
  BIconController,
} from 'bootstrap-icons-vue';

export default {
  name: 'App',
  components: {
    BIconThreeDots,
    BIconBoxArrowRight,
    BIconCardList,
    BIconFilePlusFill,
    BIconQuestionCircleFill,
    BIconCloudUploadFill,
    BIconController,
  },
  setup() {
    provideToast({ maxToasts: 5 });
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      workout: null,
      workoutToEdit: null,
      userWorkouts: [],
      showAddEditWorkoutModal: false,
      documents: [],
      userName: null,
      dbConnection,
      uid: null,
      isMobile: true,
      initializing: true,
      menuOpen: false,
    };
  },
  computed: {},
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
      if (this.menuOpen) {
        this.dbConnection.getWorkouts(localStorage.uid).then((workouts) => {
          this.userWorkouts = workouts;
        });
      }
    },
    login() {
      this.dbConnection.login();
    },
    async logout() {
      await this.dbConnection.logout();
      this.uid = null;
      this.menuOpen = false;
      this.$router.push({ name: 'login' });
    },
    goto(where) {
      this.$router.push({ name: where, state: { uid: this.uid } });
      this.menuOpen = false;
    },
  },
  mounted() {},
};
</script>
<style lang="scss">
@import 'scss/custom';
@import 'node_modules/bootstrap/scss/bootstrap';
</style>
<style>
.menuIcon {
  width: 2.5em;
  height: 2.5em;
  margin-top: 15px;
  background-color: #72a7ba;
  border-radius: 50%;
  padding: 5px;
}
.menuHeader {
  z-index: 10;
  position: absolute;
  margin-right: 5px;
  right: 10px;
  top: 0px;
  display: flex;
  flex-direction: column;
}
.menuItem {
  display: flex;
  justify-content: flex-end;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.footer {
  padding-top: 20px;
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
  align-items: center;
  justify-content: flex-end;
}
.footer > * {
  margin: 0.25rem;
}

.mobileView {
  max-width: 600px;
  margin: auto;
}

.headerImg {
  display: flex;
  justify-content: center;
  margin-top: 80px;
  margin-bottom: 30px;
}
.intro {
  padding-top: 150px;
}
.loginButton {
  display: flex;
  justify-content: center;
}
</style>
